<template>

  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.AssociationBusinessInformation')"
    width="900px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >

    <div style="padding:0 0 5px 0">
      <span>
        {{ $t('SeaExport.BusinessNo') }}：{{ aData.bNo }}&nbsp;&nbsp;&nbsp;
        {{ $t('SeaExport.BusinessStatus') }}：{{ BusinessStatus }}&nbsp;&nbsp;&nbsp;
      </span>
    </div>
    <div style="width:800px;height:570px">
      <fieldset>
        <legend>{{ $t('SeaExport.DangerousGoods') }}</legend>
        <div style="display:flex;flex-direction:row">
          <el-form
            label-width="190px"
            label-position="left"
            style="display:flex;flex-direction:column"
          >
            <el-form-item class="label-none custom">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="danger.gridOptions"
                :column-defs="danger.columnDefs"
                :row-data="specialGoods"
                style="width:100%;height:200px"
                @gridReady="params=>danger.gridApi=params.api"
              />
              <div style="width:100%">
                <div style="float:right;padding:5px">
                  <el-button type="primary" :disabled="!isEditing">{{ $t('SpecialGoods.Add') }}</el-button>
                  <el-button type="danger" :disabled="!isEditing">{{ $t('SpecialGoods.Delete') }}</el-button>
                  <el-button type="primary" :disabled="!isEditing">{{ $t('SpecialGoods.Import') }}</el-button>
                  <el-button type="primary" :disabled="!isEditing">{{ $t('SpecialGoods.FillIn') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.CLASSNO')">
              <el-input v-model="editObj.danClassNo" :disabled="!isEditing" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.UNNO')">
              <el-input v-model="editObj.danUNNo" :disabled="!isEditing" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.PACKING')">
              <el-input v-model="editObj.danPacking" :disabled="!isEditing" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DangerousGoodsLabel')">
              <el-input v-model="editObj.danLable" :disabled="!isEditing" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.EMS')">
              <el-input v-model="editObj.danEMS" :disabled="!isEditing" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.Point')">
              <el-input v-model="editObj.danPoint" :disabled="!isEditing" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MedicalEmergencyGuideNo')">
              <el-input v-model="editObj.danMfagNo" :disabled="!isEditing" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.man24')">
              <el-input v-model="editObj.dan24man" :disabled="!isEditing" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.tel24')">
              <el-input v-model="editObj.dan24tel" :disabled="!isEditing" />
            </el-form-item>
          </el-form>
          <el-form
            label-width="190px"
            label-position="left"
            style="display:flex;flex-direction:column;margin-left:20px"
            :disabled="!isEditing"
          >
            <el-form-item :label="$t('SpecialGoods.ResponsibleParty')">
              <el-input v-model="editObj.responsibleParty" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.HSCODE')">
              <el-input v-model="editObj.hsCode" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.PickTime')">
              <el-input v-model="editObj.danPickTime" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.SeaPullution')">
              <el-input v-model="editObj.danSeaPullution" :placeholder="$t('SpecialGoods.OnlyEnterYN')" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.CorrectTransportName')">
              <el-input v-model="editObj.correctTransportName" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.SecondarySpecialGoods')">
              <el-input v-model="editObj.secondarySpecialGoods" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.GrossWeight')">
              <el-input-number v-model="editObj.grossWeight" :min="0" controls-position="right" style="width:190px" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.NeatWeight')">
              <el-input-number v-model="editObj.neatWeight" :min="0" controls-position="right" style="width:190px" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.OuterPackagingType')">
              <el-input v-model="editObj.outerPackagingType" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.OuterPackagingQuantity')">
              <el-input-number v-model="editObj.outerPackagingQuantity" :min="0" controls-position="right" style="width:190px" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.InnerPackagingType')">
              <el-input v-model="editObj.innerPackagingType" :placeholder="$t('SpecialGoods.ThisFieldRequired')" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.InnerPackagingQuantity')">
              <el-input-number v-model="editObj.InnerPackagingQuantity" :min="0" controls-position="right" style="width:190px" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.Remark')">
              <el-input v-model="editObj.remark" type="textarea" :rows="2" />
            </el-form-item>
            <el-form-item :label="$t('SpecialGoods.PackingCode')">
              <el-input v-model="editObj.packingCode" />
            </el-form-item>
          </el-form>
        </div>
      </fieldset>
    </div>
    <br>
    <div style="width:810px;height:298px">
      <fieldset>
        <legend>{{ $t('SeaExport.ContainerInfo') }}</legend>
        <div style="display:flex;flex-direction:column">
          <div style="padding:5px 0">
            <el-button :disabled="!isEditing" type="primary">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
            <el-button :disabled="!isEditing" type="danger">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
          </div>
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="box.gridOptions"
            :column-defs="box.columnDefs"
            :row-data="containerUsages"
            style="width:100%;height:220px"
            @gridReady="params=>box.gridApi=params.api"
          />
        </div>
      </fieldset>
    </div>

    <span slot="footer">
      <el-button type="primary" @click="addEventHander">{{ $t('SeaExport.Synchronization') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('SeaExport.Close') }}</el-button>
    </span>

  </el-dialog>
</template>
<script>
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import StrUtils from '@/utils/StrUtils'
import { getContainerUsages } from '@/api/seaExport/specialGoods'
import { synchronizationSpecialContainer } from '@/api/seaExport/containerUsage'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'

export default {
  name: 'SpecialGoodsDialog',
  props: {
    visible: { type: Boolean, required: true },
    aData: { type: Object, required: false },
    oJob: { type: Object, default: null },
    job: { type: Object, default: null }
  },
  data() {
    return {
      isEditing: false,
      innerVisible: false,
      specialGoods: [],
      editObj: {},
      BusinessStatus: '',
      containerUsages: [],
      danger: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowClicked: this.goodsItemClickHandler
        },
        columnDefs: [
          {
            headerName: '',
            field: '',
            width: 65,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('SeaExport.SpecialCargoNumber'),
            field: 'danNo',
            width: 130
          },
          {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
            field: 'englishCommodity',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: this.isEditing,
              tag: 'cargo-cell-input'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
            field: 'chineseCommodity',
            width: 100
          },
          {
            headerName: 'SONO.',
            field: '',
            width: 100
          }
        ],
        rowData: [],
        gridApi: null
      },
      box: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: '',
            field: '',
            width: 65,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('SeaExport.ContainerSize'),
            field: 'eqSize',
            width: 100,
            cellRenderer: (params) => {
              return this.eqSizeItemLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerType'),
            field: 'eqType',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.ContainerNo'),
            field: 'containerNo',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.SealNo'),
            field: 'sealNo',
            width: 100
          }
        ],
        rowData: [],
        gridApi: null
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.show()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.show()
    }
  },
  methods: {
    async show() {
      this.BusinessStatus = this.getJobStateCN(this.aData.jobStatus)

      if (this.job.specialGoods != null && this.job.specialGoods.length > 0) {
        this.specialGoods = this.job.specialGoods
        this.$nextTick(async() => {
          await this.setGridSelect()
          this.goodsItemClickHandler()
        })

        // 目前没有危险品编号，需要生成
        if (this.editObj && StrUtils.isEmpty(this.editObj.danNo)) {
          this.editObj.danNo = JobUtils.createDanNo(this.job)
        }
      }
    },
    // 设置 选中行(加载数据后默认选中第一行记录)
    setGridSelect(selectLastRow = false) {
      const nodes = this.danger.gridOptions.api.getRenderedNodes()

      // 选中最后一行记录(用于 行 新增，删除)
      if (selectLastRow) {
        let index = 0
        for (const item of nodes) {
          if (index === nodes.length - 1) {
            item.setSelected(true)
            this.editObj = item.data
          }
          index++
        }
      } else {
        // 默认选中第一个
        for (const item of nodes) {
          item.setSelected(true)
          this.editObj = item.data
          break
        }
      }
    },

    goodsItemClickHandler(event = null) {
      if (event) {
        this.editObj = event.data
      }
      // 获取 ContainerUsages
      this.containerUsages = []
      if (this.editObj && !StrUtils.isEmpty(this.editObj.uuid)) {
        getContainerUsages({ specialGoodsUuid: this.editObj.uuid }).then(res => { this.loadUsageResultHandler(res.data) })
      }
    },

    loadUsageResultHandler(data) {
      if (this.editObj) {
        this.containerUsages = data
      }
    },
    addEventHander() {
      this.$confirm('确定同步之后不允许再撤销,是否确认同步？', this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        synchronizationSpecialContainer({ removeJobUuid: this.oJob.uuid, addJobUuid: this.job.uuid }).then(res => {
          this.$emit('refreshCache')
          this.innerVisible = false
        })
      })
    },
    eqSizeItemLabelFunc(value) {
      const eqSize = EQSize.getEQSizeByCode(value)
      return eqSize === null ? '' : eqSize.name
    },
    getJobStateCN(state) {
      if (state === 0) {
        return this.$t('CargoMsg.Cargo_PositiveOperation')
      } else if (state === 1) {
        return this.$t('CargoMsg.Cargo_Submitted')
      } else if (state === 2) {
        return this.$t('CargoMsg.Cargo_Approved')
      } else if (state === 3) {
        return this.$t('CargoMsg.Cargo_ShutOut')
      } else if (state === -1) {
        return this.$t('CargoMsg.Cargo_PendingPrice')
      } else if (state === 11) {
        return this.$t('CargoMsg.Cargo_PreSubmission')
      } else if (state === 12) {
        return this.$t('CargoMsg.Cargo_Denied')
      }
      return this.$t('CargoMsg.Cargo_UnKnownStatus')
    }
  }
}
</script>

<style>
</style>
